import { applyMergeRules } from "./merge";

/**
 * 对多个列应用相同的合并规则
 *
 * @param tableBody 表格数据
 * @param columnIndices 需要合并的列索引数组
 * @param mergeRules 合并规则
 * @returns 处理后的表格数据
 */
export function applyMergeRulesToColumns(
  tableBody: any[][],
  columnIndices: number[],
  mergeRules: Array<{ startRow: number; rowSpan: number }>
): any[][] {
  let result = JSON.parse(JSON.stringify(tableBody));

  // 依次对每一列应用合并规则
  columnIndices.forEach((columnIndex) => {
    result = applyMergeRules(result, columnIndex, mergeRules);
  });

  return result;
}
